function removeHeroSpeedHint() {
  const hero = document.querySelector("#top");
  if (!hero) return false;

  const target = Array.from(hero.querySelectorAll("div")).find((element) =>
    element.textContent?.trim() === "Maintenez le clic — accélérez",
  );

  if (target) target.remove();
  return true;
}

function boot() {
  if (removeHeroSpeedHint()) return;

  const observer = new MutationObserver(() => {
    if (removeHeroSpeedHint()) observer.disconnect();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
  boot();
}
